module.exports = __webpack_public_path__ + "static/media/YC.d3a105e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/YC.svg
// module id = 305
// module chunks = 25